import { Selector } from '@ngxs/store';
import { PremiumRoleState, PremiumRoleStateModel } from './premium-role.state';

export class PremiumRoleSelectors {
  @Selector([PremiumRoleState])
  static roles(state: PremiumRoleStateModel) {
    return state.roles;
  }

  @Selector([PremiumRoleState])
  static loading(state: PremiumRoleStateModel) {
    return state.loading;
  }

  @Selector([PremiumRoleState])
  static error(state: PremiumRoleStateModel) {
    return state.error;
  }
}
